// @flow

import { ReducerRegistry } from '../base/redux';

import {
    ADD_CANDP_URL,
    RECEIVE_CANDP_URL,
    REMOVE_CANDP_URL,
    REMOVE_MOBILE_CANDP_URL } from './actionTypes';

const DEFAULT_STATE = {
    addCUrl: undefined,
    getCUrl: undefined

};

ReducerRegistry.register('features/clickandpledge', (state = DEFAULT_STATE, action) => {

    switch (action.type) {
    case ADD_CANDP_URL: {
        return {
            ...state,
            addCUrl: action.addCUrl
        };
    }
    case RECEIVE_CANDP_URL: {
        const url = action.getCUrl;

        return {
            ...state,
            getCUrl: action.getCUrl ? url : state.getCUrl
        };
    }

    case REMOVE_CANDP_URL: {
        return {
            ...state,
            getCUrl: undefined
        };
    }

    case REMOVE_MOBILE_CANDP_URL: {
        return {
            ...state,
            getCUrl: undefined
        };
    }
    }


    return state;
});
